import { useMemo } from "react";

import { useFragment } from "@apollo/client";

import { type MyLensesLens } from "../../gql-generated/types";
import { lensFragment } from "../../shared/api/fragments";

import {
    type DistributionRestrictionsResult,
    makeDistributionRestrictionsResult,
} from "./makeDistributionRestrictionsResult";

export const useLensDistributionRestrictionsDeduped = (lensId?: string): DistributionRestrictionsResult => {
    const { data, complete } = useFragment<MyLensesLens>({
        fragment: lensFragment,
        fragmentName: "Lens",
        from: {
            __typename: "Lens",
            id: lensId ?? "",
        },
    });

    return useMemo(() => {
        const distributionRestrictions =
            complete && data.distributionRestrictionsList.length > 0 ? data.distributionRestrictionsList : [];
        return makeDistributionRestrictionsResult(distributionRestrictions);
    }, [data, complete]);
};
